<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'personal-taskCenter',
  components: { PageTable },
}
</script>
